import { useEffect, useState } from 'react';
import { Modal, message } from 'antd';
import dayjs from 'dayjs';
import ScheduleStatus from './ScheduleStatus';
import { scheduleOverride, replaceScheduleWorkmen } from '../../services/crew';
import useAuth from '../../hooks/useAuth';
  const ScheduleConflictHandler = ({ response, crew, onDone, values, payloadForReplace, scheduleOverridePermission, onFiltersReady, onCloseFilter}) => {
  const { userConfig } = useAuth();
  const [open, setOpen] = useState(false);
  const [conflictAssignments, setConflictAssignments] = useState([]);
  const [successAssignments, setSuccessAssignments] = useState([]);
  const [conflictMetadata, setConflictMetadata] = useState({});
  useEffect(() => {
    if (!response) return;
    const conflictMetadataMap = {};
    const conflicts = [];
    response?.results?.forEach((result, resultIndex) => {
      if (Array.isArray(result.conflictingEmployees)) {
        result.conflictingEmployees.forEach(employee => {
          conflicts.push(employee);
          conflictMetadataMap[employee._id] = {
            resultIndex,
            newCrewId: result.newCrewId,
            crewId: result.crewId,
            resultDate: result.date
          };
        });
      }
    });
const successes =
      response?.createdAssignments ??
      response?.createdAssignmentsCount ??
      [];

    setConflictAssignments(conflicts);
    setConflictMetadata(conflictMetadataMap);
    setSuccessAssignments(successes);

    if (conflicts.length > 0) {
      setOpen(true);
    }
  }, [response]);
const handleCancel = () => {
    onCloseFilter?.();
    setOpen(false);
  };
const handleOverrideSchedule = async (selectedConflicts = null) => {
  try {
    const conflictsToUse =
      Array.isArray(selectedConflicts) && selectedConflicts.length
        ? selectedConflicts
        : conflictAssignments;
        

    if (!conflictsToUse.length) {
      message.warning('No conflicts to override.');
      return;
    }

    for (const conflict of conflictsToUse) {
      const metadata = conflictMetadata[conflict._id] || {};
      const resultIndex = metadata.resultIndex ?? 0;
      
      let targetCrew = null;
      
      if (conflict.crew && Array.isArray(crew)) {
        targetCrew = crew.find(c => c._id === conflict.crew || c.id === conflict.crew);
      }
      
      if (!targetCrew && Array.isArray(crew) && crew[resultIndex]) {
        targetCrew = crew[resultIndex];
      }
      
      if (!targetCrew && Array.isArray(crew) && crew.length > 0) {
        targetCrew = crew[0];
      }

      const newCrewId = metadata.newCrewId || response?.conflictingEmployees?.[0]?.editingCrewId || targetCrew?._id || targetCrew?.id || payloadForReplace?.crewId;

      const startTime = targetCrew?.startTime || values?.scheduleIn || crew[resultIndex]?.startTime;
      const endTime = targetCrew?.endTime || values?.scheduleOut || crew[resultIndex]?.endTime;
      const assignDate = conflict.date || metadata.resultDate || response?.date;
      const payload = {
        newCrewId,
        start: startTime,
        end: endTime,
        date: assignDate,
        conflictingEmployees: [
          {
            _id: conflict._id,
            crew: conflict.crew,
            isScheduleOverridden: conflict.isScheduleOverridden,
            employeeId: conflict.employeeId,
            date: conflict.date,
            start: conflict.start,
            end: conflict.end,
            createdAt: conflict.createdAt,
          },
        ],
      };
      
      await scheduleOverride(payload);
      const conflictReplace = [conflict]
      
      if (crew ) {
        const payload = conflictReplace.map(
        row => ({ 
            id: row?.id || row?.employeeId,
            shiftId: row?.shiftId,
            workRuleTransfer: crew[resultIndex]?.workRuleTransfer || row?.workRuleTransfer,
            payscale: crew[resultIndex]?.payScale || row?.payScale || row?.payscale,
            wbsIo: crew[resultIndex]?.eventName || row?.eventName || row?.event,
            task: crew[resultIndex]?.task || row?.task,
            premium: crew[resultIndex]?.premium || row?.premium,
            scheduleIn: startTime || crew[resultIndex]?.startTime,
            scheduleOut: endTime || crew[resultIndex]?.endTime,
            assignDate: assignDate,
            startTime: row?.start,
            endTime: row?.end,
          })
        );
          
        try { await replaceScheduleWorkmen(payload); } 
        catch (err) { console.error('Error in replaceScheduleWorkmen during override:', err); }
      }
    }
    if (payloadForReplace && payloadForReplace !== null) {
      const payload = conflictsToUse.map(
        row => ({
          id: row?.id || row?.employeeId,
          shiftId: row?.shiftId,
          workRuleTransfer: payloadForReplace?.workRuleTransfer || row?.workRuleTransfer,
          payscale: payloadForReplace?.payscale || row?.payScale || row?.payscale,
          wbsIo: payloadForReplace?.wbsIo || row?.eventName || row?.event,
          task: payloadForReplace?.task || row?.task,
          premium: payloadForReplace?.premium || row?.premium,
          scheduleIn: payloadForReplace?.scheduleIn || (row?.scheduleIn || row?.start),
          scheduleOut: payloadForReplace?.scheduleOut || (row?.scheduleOut || row?.end),
          assignDate: payloadForReplace?.assignDate || dayjs(date).format('YYYY-MM-DD'),
          startTime: payloadForReplace?.startTime || row?.start,
          endTime: payloadForReplace?.endTime || row?.end,
        })
      );
      try { await replaceScheduleWorkmen(payload); } 
      catch (err) { console.error('Error in replaceScheduleWorkmen during override:', err); }
    }
    message.success('Schedule override completed');
    handleCancel();
    onDone?.();
    setTimeout(() => window.location.reload(), 700);
  } catch (err) {
    console.error('Override failed:', err);
    message.error('Error overriding schedule.');
  }
};
 if (!open) {
    return null;
  }

  return (
    <Modal
      open={open}
      footer={null}
      width={950}
      onCancel={handleCancel}
      bodyStyle={{ padding: 0 }}
      destroyOnClose
    >
      <ScheduleStatus
        conflictToAssign={conflictAssignments}
        successToAssign={successAssignments}
        onOverride={handleOverrideSchedule}
        onCancel={handleCancel}
        scheduleOverridePermission={scheduleOverridePermission}
        onFiltersReady={onFiltersReady}
      />
    </Modal>
  );
};

export default ScheduleConflictHandler;